import { createContext, useContext } from 'react';
import { Session, AuthChangeEvent } from '@supabase/supabase-js';

interface User {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  businessName: string;
}

interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  isRestricted: boolean;
  session: Session | null;
  login: (email: string, password: string) => Promise<void>;
  signup: (email: string, password: string, metadata?: Record<string, string>) => Promise<{ requiresConfirmation: boolean }>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
export const LastAuthEventContext = createContext<AuthChangeEvent | null>(null);

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) throw new Error('useAuth must be used within an AuthProvider');
  return context;
}

export function useLastAuthEvent() {
  return useContext(LastAuthEventContext);
}
